import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsBackendService {
  private http = inject(HttpClient);

 
  articoliDpiUrl = environment.ildatoArticoliDpi + 'api/settings';

  getLayoutSettings(): Observable<any> {
    return this.http.get<any>(`${this.articoliDpiUrl}/layout`);    
  }
}
